import Honeybadger from '@honeybadger-io/js'
import { isLocalStorageAvailable } from './local-storage-availability'

const DEFAULT_APP_ENV = 'development'
const environment = import.meta.env.VITE_APP_ENV || DEFAULT_APP_ENV
const RELOAD_COUNT_KEY = `assets-version-reload-count-${environment}`
const VERSION_KEY = `assets-version-${environment}`

export const startVersionChecker = async (): Promise<void> => {
  if (!isLocalStorageAvailable()) {
    return
  }

  const checkInterval = import.meta.env.VITE_ASSETS_CHECK_SECONDS || '300'
  const interval = 1000 * parseInt(checkInterval)

  checkAssetsVersion()

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkAssetsVersion()
    }
  })

  setInterval(() => {
    checkAssetsVersion()
  }, interval)
}

async function checkAssetsVersion() {
  if (environment && environment !== DEFAULT_APP_ENV) {
    try {
      const reloadCount = parseInt(localStorage.getItem(RELOAD_COUNT_KEY) || '0', 10)
      const localVersion = localStorage.getItem(VERSION_KEY)

      if (reloadCount >= 3) {
        localStorage.removeItem(RELOAD_COUNT_KEY)
        return
      }

      if (localVersion) {
        const response = await fetch('/version.txt')
        const remoteVersion = await response.text()

        if (remoteVersion.length <= 20 && localVersion !== remoteVersion) {
          localStorage.setItem(VERSION_KEY, remoteVersion)
          localStorage.setItem(RELOAD_COUNT_KEY, (reloadCount + 1).toString())
          window.location.reload()
        } else {
          localStorage.removeItem(RELOAD_COUNT_KEY)
        }
      } else {
        await getAndStoreRemoteVersion(reloadCount)
      }
    } catch (error) {
      Honeybadger.notify('Error checking version', {
        context: {
          error: JSON.stringify(error),
          environment: environment,
          reloadCountKey: RELOAD_COUNT_KEY,
          versionKey: VERSION_KEY
        },
        tags: 'version-checker'
      })
    }
  }
}

async function getAndStoreRemoteVersion(reloadCount: number) {
  const response = await fetch('/version.txt')
  const remoteVersion = await response.text()

  if (remoteVersion.length <= 20) {
    localStorage.setItem(VERSION_KEY, remoteVersion)
  }

  if (reloadCount >= 3) {
    localStorage.removeItem(RELOAD_COUNT_KEY)
    return
  }

  window.location.reload()
}
